import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  Switch,
  Form,
  Input,
  Button,
  message,
  InputNumber,
  Select,
  Skeleton,
} from "antd";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import DeleteDiscount from "@general/deleteDiscount";
import DatePicker from "@general/datePicker";
import moment from "moment-jalaali";

function DiscountForm({ formData, onDoUpdateData, onDoCloseDrawer, id }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [selectableProducts, setSelectableProducts] = useState([]);
  const [selectableUsers, setSelectableUsers] = useState([]);
  const UDPADTEDISCOUNT = gql`
    mutation updateDiscount(
      $updateDiscountInput: UpdateDiscountInput!
      $id: ID!
    ) {
      updateDiscount(updateInput: $updateDiscountInput, id: $id)
    }
  `;
  const GETUSERSANDPRODUCTS = gql`
    query ($paginateInput: PaginateInput!) {
      getProducts(paginateInput: $paginateInput, searchInput: {}) {
        id
        name
      }
      getUsers(paginateInput: $paginateInput, searchInput: {}) {
        id
        name
        mobile
      }
    }
  `;

  
  const [runUpdateDiscount, updateDiscount] = useMutation(UDPADTEDISCOUNT, {
    onCompleted() {
      message.success("اطلاعات تخفیف بروزرسانی شد.");
      onDoUpdateData();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! تخفیف بروزرسانی نشد.");
    },
  });
  const [getUsersAndProducts, usersAndProducts] = useLazyQuery(
    GETUSERSANDPRODUCTS,
    {
      onCompleted({ getProducts, getUsers }) {
        const arrangedProducts = [{ value: "all", label: "همه خدمات" }];
        getProducts.map((user) => {
          arrangedProducts.push({
            value: user.id,
            label: user.name ? user.name : user.mobile,
          });
        });
        setSelectableProducts(arrangedProducts);

        const arrangedUsers = [{ value: "all", label: "همه کاربران" }];
        getUsers.map((user) => {
          arrangedUsers.push({
            value: user.id,
            label: user.name ? user.name : user.mobile,
          });
        });
        setSelectableUsers(arrangedUsers);
      },
    }
  );
console.log(formData);

  useEffect(() => {
    form.setFieldsValue(formData);
    getUsersAndProducts({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 500,
        },
      },
    });
  }, [formData]);

  const onDoUpdateDiscount = (updateDiscountInput) => {
      if (updateDiscountInput.userIds[0] === "all") updateDiscountInput.userIds = [];
    if (updateDiscountInput.productIds[0] === "all") updateDiscountInput.productIds = [];
    runUpdateDiscount({
      variables: {
        id,
        updateDiscountInput: {
          ...updateDiscountInput,
        },
      },
    });
  };
  if (!formData)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  else
    return (
      <>
        <Row>
          <Space align>
            <p>ویرایش: </p>
            <Switch onChange={() => setEditable(!editable)} />
          </Space>
        </Row>
        <Form
          layout="vertical"
          onFinish={onDoUpdateDiscount}
          form={form}
          disabled={!editable}
        >
          <Row>
            <Col xs={24} md={12}>
              <Row>
                <Form.Item
                  name="title"
                  id="title"
                  label="عنوان"
                  rules={[
                    {
                      required: true,
                      message: "لطفا کد تخفیف را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder={"عنوان"} />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  name="productIds"
                  id="productIds"
                  label="خدمات مشمول"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام خدمات مشمول تخفیف را انتخاب کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select
                    showSearch
                    mode="multiple"
                    allowClear
                    loading={usersAndProducts.loading}
                    listHeight={200}
                    style={{
                      width: 280,
                    }}
                    placeholder={"خدمات"}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    filterSort={(optionB, optionA) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={selectableProducts}
                  />
                </Form.Item>
              </Row>
              <Row gutter={30}>
                <Form.Item
                  name="percent"
                  id="percent"
                  label="درصد تخفیف"
                  rules={[
                    {
                      required: true,
                      message: "لطفا درصد تخفیف را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    min={0}
                    max={100}
                    formatter={(value) => `${value}%`}
                    parser={(value) => value.replace("%", "")}
                  />
                </Form.Item>
              </Row>

              <Row>
                <Form.Item
                  name="maxCount"
                  id="maxCount"
                  label="تعداد"
                  rules={[
                    {
                      required: true,
                      message: "لطفا حداکثر تعداد استفاده را مشخص کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber min={1} style={{ width: "150px" }} />
                </Form.Item>
              </Row>
            </Col>
            <Col xs={24} md={12}>
              <Row>
                <Form.Item
                  name="code"
                  id="code"
                  label="کد تخفیف"
                  rules={[
                    {
                      required: true,
                      message: "لطفا کد تخفیف را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder={"کد تخفیف"} />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  name="userIds"
                  id="userIds"
                  label="کاربران مشمول"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام کاربران مشمول تخفیف را انتخاب کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select
                    showSearch
                    mode="multiple"
                    allowClear
                    loading={usersAndProducts.loading}
                    listHeight={200}
                    style={{
                      width: 280,
                    }}
                    placeholder={"کاربران"}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    filterSort={(optionB, optionA) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={selectableUsers}
                  />
                </Form.Item>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item
                    label="تاریخ انقضا"
                    name="expiresAt"
                    rules={[{ required: true, message: "این فیلد ضروری است" }]}
                  >
                    <DatePicker
                      showToday={false}
                      format="YYYY/MM/DD"
                      className="rtl"
                      placeholder="تاریخ انقضا"
                      disabledDate={(current) =>
                        current < moment().endOf("day")
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Space style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={updateDiscount.loading && true}
            >
              به روزرسانی
            </Button>
            <DeleteDiscount
              id={id}
              onDeleteDiscount={onDoUpdateData}
              closeDrawer={onDoCloseDrawer}
            >
              <Button danger type="text">
                حذف تخفیف
              </Button>
            </DeleteDiscount>
          </Space>
        </Form>
      </>
    );
}

export default DiscountForm;
